
import mobx, { extendObservable, action } from 'mobx';
import axios from 'axios';
import { includes, map } from 'lodash';
import eb from '../utils/EventBus'

class UserStore {

	constructor() {
		extendObservable(this, {
			loading: true,
			users: [],
			yesno: [],
			filteredUsers: [],
			userIds: [],
			selectedUser: undefined,
			operation: undefined,
			selectedShOption: [],
     		selectedRvwOption: [],
     		selectedAppOption: [],
     		selectedAdmOption: [],
     		selectedOrgOption: [],
     		selectedAdm: null,
     		selectedSh: null,
     		selectedRvw: null,
     		selectedApp: null,
     		selectedOrg: null
		});

	}

	loadAllUsers = () => {
		axios.get('/api/v1/user/users').then(({ data }) => {
			this.loading = false;
			this.users = data;
			console.log(this.users);
			this.filteredUsers = data;
		});
	}

	loadAdm = () => {
      axios.get('/api/v1/userlist/fndlookup').then(({ data }) => {
        this.selectedAdmOption = data.map(fndlookup => ({value: fndlookup.lookupcode, label: `${fndlookup.meaning}`}));
      });
    }

    setSelectedAdm = action((admoption) => {
      this.selectedAdm = admoption;
      const sAdm = this.selectedAdm.value;
      this.setAdmin(sAdm);
    })

	loadSh = () => {
      axios.get('/api/v1/userlist/fndlookup').then(({ data }) => {
        this.selectedShOption = data.map(fndlookup => ({value: fndlookup.lookupcode, label: `${fndlookup.meaning}`}));
      });
    }

    setSelectedSh = action((shoption) => {
      this.selectedSh = shoption;
      const sSh = this.selectedSh.value;
      this.setSharedWith(sSh);
    })

   loadRvw = () => {
      axios.get('/api/v1/userlist/fndlookup').then(({ data }) => {
        this.selectedRvwOption = data.map(fndlookup => ({value: fndlookup.lookupcode, label: `${fndlookup.meaning}`}));
      });
    }

    setSelectedRvw = action((rvwoption) => {
      this.selectedRvw = rvwoption;
      const sRvw = this.selectedRvw.value;
      this.setReviewer(sRvw);
    })

    loadApp = () => {
      axios.get('/api/v1/userlist/fndlookup').then(({ data }) => {
        this.selectedAppOption = data.map(fndlookup => ({value: fndlookup.lookupcode, label: `${fndlookup.meaning}`}));
      });
    }

    setSelectedApp = action((appoption) => {
      this.selectedApp = appoption;
      const sApp = this.selectedApp.value;
      this.setApprover(sApp);
    })


    loadOrgs = () => {
      axios.get('/api/v1/query/org').then(({ data }) => {
        this.selectedOrgOption = data.map(org => ({value: org.orgid, label: `${org.orgname}`}));
      });
    }

    setSelectedOrg = action((orgoption) => {
      this.selectedOrg = orgoption;
      const sOrg = this.selectedOrg.value;
      this.setOrgId(sOrg);
      console.log(this.selectedOrg.orgname);
    })



	onSubmit = () => {
		const { userName } = this;
		console.log(userName)

		this.loading = true;
		this.users = [];

		axios.get('/api/v1/user/users').then(({ data }) => {
			this.loading = false
			this.users = data
		});
	}


	setSearch = action((val) => {
		console.log(val)

		this.filteredUsers = this.users.filter(i => i.username.indexOf(val) > -1);
	})

	creUser = () => {
		//console.log(' inside cre user ');

        if ((this.selectedUser.firstname === null) || (this.selectedUser.firstname ==="") || (this.selectedUser.firstname===undefined)) {
          alert('First Name cannot be null, please enter first name');
          return false;
        } else if ((this.selectedUser.lastname === null) || (this.selectedUser.lastname ==="") || (this.selectedUser.lastname===undefined)) {
          alert('Last Name cannot be null, please enter last name');
          return false;
        } else if ((this.selectedUser.email === null) || (this.selectedUser.email ==="") || (this.selectedUser.email===undefined)) {
          alert('Email cannot be null, please enter email');
          return false;
        } else if ((this.selectedUser.username === null) || (this.selectedUser.username ==="") || (this.selectedUser.username===undefined)) {
          alert('Username cannot be null, please enter username');
          return false;
        } else if ((this.selectedUser.password=== null) || (this.selectedUser.password ==="") || (this.selectedUser.password===undefined)) {
          alert('Password cannot be null, please enter password');
          return false;
        }

        

		axios.post('/api/v1/user/create', {
			user: this.selectedUser
		})
			.then((response) => {
				this.loadAllUsers();
				eb.emit('toast', {
					status: 'success',
					text: 'User created'
				})
				eb.emit('user-created');
			});

	}

	updUser = () => {
		axios.post('/api/v1/user/update', {
			user: this.selectedUser
		})
			.then((response) => {
				if(response.data!="error"){
				this.loadAllUsers();
				eb.emit('toast', {
					status: 'success',
					text: 'User updated'
				})
				eb.emit('user-updated');
				}else{
                    eb.emit('toast', {
                        status: 'error',
                        text: 'User password blank'
                    })
				}
			});
	}

	loadUser = (userId) => {

		axios.get(`/api/v1/user/${userId}`).then(({ data }) => {
			this.loading = false;
			this.selectedUser = data;
		});
	}

	setFirstName = action((val) => {
		console.log(val)
		this.selectedUser.firstname = val;
	})

	setLastName = action((val) => {
		console.log(val)
		this.selectedUser.lastname = val;
	})

	setEmailAddress = action((val) => {
		console.log(val)
		this.selectedUser.email = val;
	})

	setUsername = action((val) => {
		console.log(val)
		this.selectedUser.username = val;
	})

	setPassword = action((val) => {
		console.log(val)
		this.selectedUser.password = val;
	})

	setNewPassword = action((val) => {
		console.log(val)
		this.selectedUser.newpassword = val;
	})

	setAdmin = action((val) => {
		console.log(val)
		this.selectedUser.admin = val;
	})

	setSharedWith = action((val) => {
		console.log(val)
		this.selectedUser.sharedwith = val;
	})

	setReviewer = action((val) => {
		console.log(val)
		this.selectedUser.reviewer = val;
	})

    setApprover = action((val) => {
		console.log(val)
		this.selectedUser.approver = val;
	})

	setOrgId = action((val) => {
		console.log(val)
		this.selectedUser.orgid = val;
	})

	setWorkPhoneNumber = action((val) => {
		console.log(val)
		this.selectedUser.workphone = val;
	})

	setMobilePhoneNumber = action((val) => {
		console.log(val)
		this.selectedUser.mobilephone = val;
	})

	setActiveFlag = action((val) => {
		console.log('inside set active flag');
		console.log(val)
      if (this.state.selected==='0') {
         this.selectedUser.activeflag = 'Y';      	
      } else {
      	this.selectedUser.activeflag = 'N';   
      }
        console.log(this.selectedUser.activeflag);
		//this.selectedUser.activeflag = val;
	})
}

const userstore = new UserStore();
export default userstore;



// WEBPACK FOOTER //
// ./src/store/user-store.js